import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

export interface Opt {
  name?: string;
  wines?: { id: number };
}

const modifyVarietal = async (varietalId: string | number, opt: Opt): Promise<any> => {
  const res = await axiosSecure.put(`${getContextRoot()}/varietal/${varietalId}`, opt);
  return res.data;
};

export default modifyVarietal;
